import { render, staticRenderFns } from "./list-dict-value.vue?vue&type=template&id=44917e28&scoped=true"
import script from "./list-dict-value.vue?vue&type=script&lang=js"
export * from "./list-dict-value.vue?vue&type=script&lang=js"
import style0 from "./list-dict-value.vue?vue&type=style&index=0&id=44917e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44917e28",
  null
  
)

export default component.exports